import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { useAuth } from 'hooks';
import OrganizationsLogin from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import Accounts from '../pages/Accounts';
import Locations from '../pages/Locations';
import LocationDetail from '../pages/LocationDetail';
import EmailMarketing from '../pages/EmailMarketing';
import EmailCampaignDetail from '../pages/EmailCampaignDetail';
import PrivateRoute from './PrivateRoute';
import {
    LoginPath,
    DashboardPath,
    OrganizationsPath,
    LocationsPath,
    LocationDetailPath,
    LogoutPath,
    EmailMarketingPath,
    EmailCampaignDetailPath
} from './Paths';

const Routes: React.FC = () => {
    const auth = useAuth();
    const isAuthenticated = auth && auth.signedIn && auth.user && auth.token;

    // Temporary bypass for dashboard development
    // TODO: Remove this when backend is ready
    const isDevelopmentBypass = false;

    return (
        <Switch>
            {/* Public Routes */}
            <Route
                exact
                path={LoginPath}
                component={OrganizationsLogin}
            />

            {/* Private Routes */}
            <PrivateRoute
                exact
                path={DashboardPath}
                component={Dashboard}
            />
            <PrivateRoute
                exact
                path={OrganizationsPath}
                component={Accounts}
            />
            <PrivateRoute
                exact
                path={LocationsPath}
                component={Locations}
            />
            <PrivateRoute
                exact
                path={LocationDetailPath}
                component={LocationDetail}
            />
            <PrivateRoute
                exact
                path={EmailMarketingPath}
                component={EmailMarketing}
            />
            <PrivateRoute
                exact
                path={EmailCampaignDetailPath}
                component={EmailCampaignDetail}
            />

            {/* Logout Route */}
            <Route
                exact
                path={LogoutPath}
            >
                <Redirect to={LoginPath} />
            </Route>

            {/* Default Redirects */}
            <Route
                exact
                path="/"
            >
                {isAuthenticated || isDevelopmentBypass ? <Redirect to={DashboardPath} /> : <Redirect to={LoginPath} />}
            </Route>

            {/* Catch all - redirect to appropriate page */}
            <Route>
                {isAuthenticated || isDevelopmentBypass ? <Redirect to={DashboardPath} /> : <Redirect to={LoginPath} />}
            </Route>
        </Switch>
    );
};

export default Routes;
